import CustomButtonSelect from "@/components/loyalty/components/CustomButtonSelect.vue";
import StatisticsService from "@/services/StatisticsService";
import CampService from "@/services/CampService";
import { mapState } from "vuex";
import Spinner from "@/manzana_library/components/Widgets/Spinner";

export default {
  components: {
    CustomButtonSelect,
    Spinner
  },

  data() {
    return {
      activeLoading: false,
      selectOptions: [ // handler used in custombuttonselect component
        { id: 0, value: "Excel", handler: 0 },
        { id: 1, value: "CSV", separated: "true", handler: 1 },
      ],
    };
  },

  computed: {
    ...mapState({
      infoName: (state) => state.stat.data.general.entity || {},
    }),
  },

  methods: {
    async exportClickMapToFile(data, format, fileName) {
      switch (format) {
        case "xls":
          try {
            await StatisticsService.exportClickMapToFileXls(data, format, fileName);
          } catch (err) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: this.$t('general.error'),
            });
          } finally {
            this.$emit("changeStatusBtnClick", false);
          }
          break;
        case "csv":
          try {
            await StatisticsService.exportClickMapToFileCsv(data, format, fileName);
          } catch (err) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: this.$t('general.error'),
            });
          } finally {
            this.$emit("changeStatusBtnClick", false);
          }
          break;
        default: break;
      }
    },

    async fileExport(type) {
      this.activeLoading = true;
      const format = type ? "csv" : "xls";
      const getExportFile = this.$store.getters.getExportFile;

      if (this.title) {
        try {
          const fileName = `${this.infoName.Name}_${this.getPeriod(this.title)}`;
          const tabName = this.gettingTabTitle(this.title);
          await StatisticsService.getAdditionalFileFormat(
            {
              campuiid: this.$route.params.id,
              state: tabName,
              ...getExportFile,
            },
            format,
            fileName,
          );
        } catch (err) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: this.$t('general.error'),
          });
          this.activeLoading = false;
        }
      } else if (this.selectedPeriod) {
        try {
          this.$emit("changeStatusBtnClick", true);
          const stepId = this.selectedTemplate.id;
          const fileName = `${this.infoName.Name}_${this.$t('campaign.forPeriod.numberClicks')}_${this.getPeriod(this.selectedPeriod)}`;
          if (stepId) {
            await this.exportClickMapToFile(
              {
                campuiid: this.$route.params.id,
                stepId,
                ...getExportFile,
              },
              format,
              fileName,
            );
          } else {
            await this.exportClickMapToFile(
              {
                campuiid: this.$route.params.id,
                launchId: this.$route.query.launchid,
                stepId: +this.$route.query.stepid,
                taskId: this.$route.query.taskid,
                ...getExportFile,
              },
              format,
              fileName,
            );
          }
        } catch (err) {
          this.$notify({
            group: 'app',
            type: 'error',
            text: this.$t('general.error'),
          });
          this.$emit("changeStatusBtnClick", false)
        }
      } else {
        if (this.$route.params.id) {
          try {
            const { CreatedOn } = await CampService.getCamp(this.$route.params.id);
            getExportFile.from = CreatedOn;
            getExportFile.to = Math.trunc(Date.now() / 1000);
            await StatisticsService.getAdditionalFileFormat(
              {
                campuiid: this.$route.params.id,
                state: null,
                ...getExportFile,
              },
              format,
              this.infoName.Name,
            );
          } catch (err) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: this.$t('general.error'),
            });
            this.activeLoading = false;
          }

        } else {
          try {
            await StatisticsService.getAdditionalFileFormat(
              {
                state: null,
                ...getExportFile,
              },
              format,
              this.infoName.Name,
            );
          } catch (err) {
            this.$notify({
              group: 'app',
              type: 'error',
              text: this.$t('general.error'),
            });
            this.activeLoading = false;
          }
        }
      }
      this.activeLoading = false;
    },

    getPeriod(val) {
      return val.replace(/-/g, ".")
        .replace(/\s\(\d\d:\d\d\)\s~\s/, "-")
        .replace(/\s\(\d\d:\d\d\)/, "");
    },
  },
};
